import {Expose, Transform, Type} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {CostViewModel} from "../../features/user/project/goals/cost.view-model";

export class CostApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public name: string;
  @Expose() public description: string | null;
  @Transform(({value}) => value !== null && value !== undefined ? value.toString() : null, { toClassOnly: true })
  @Expose() public priceNet: string;
  @Type(() => Date)
  @Expose() public incurredAt: Date | null;
  @Expose() public project: string | null;
  @Expose() public goal: string | null;
  @Expose() public task: string | null;
  @Type(() => Date)
  @Expose() public createdAt: Date | null;
  @Type(() => Date)
  @Expose() public updatedAt: Date | null;

  public static toCostVM(apiModel: CostApiModel): CostViewModel {
    return {
      apiModel,
      '@id': apiModel['@id'],
      id: Number(apiModel.id),
      name: apiModel.name,
      description: apiModel.description || null,
      priceNet: apiModel.priceNet,
      incurredAt: apiModel.incurredAt,
      project: apiModel.project || null,
      goal: apiModel.goal || null,
      task: apiModel.task || null,
      createdAt: apiModel.createdAt,
      updatedAt: apiModel.updatedAt,
    };
  }

  public static fromCostVM(viewModel: CostViewModel): CostApiModel {
    const apiModel = viewModel.apiModel || new CostApiModel();
    apiModel['@id'] = viewModel['@id'];
    apiModel.id = viewModel.id;
    apiModel.name = viewModel.name;
    apiModel.description = viewModel.description || null;
    apiModel.priceNet = viewModel.priceNet;
    apiModel.incurredAt = viewModel.incurredAt || null;
    apiModel.project = viewModel.project || null;
    apiModel.goal = viewModel.goal || null;
    apiModel.task = viewModel.task || null;

    return apiModel;
  }
}
